/* ヘルプメッセージ, バリデーション */
import React, { useCallback } from 'react';

interface Props {
  user_role?: string;
  has_loan_aproval_system: boolean; // 融資稟議システムが導入済か未済か
}

const StaffNavbar: React.FC<Props> = ({ user_role, has_loan_aproval_system }) => {
  // 案件一覧をクリックする
  const handleClickReceptionList = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/staff/list`;
  };
  // メンテナンスをクリックする
  const handleClickMaintenance = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/maintenance/menu`;
  };
  // 顧客宛文書をクリックする
  const handleClickCustomerDocument = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/customer_document/list`;
  };
  // 法人一覧をクリックする
  const handleClickCorporateList = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/staff/corporate`;
  };
  // 案件一覧
  const jsxReceptionList = useCallback(() => {
    if (user_role === 'staff' && !has_loan_aproval_system) {
      return (
        <a onClick={handleClickReceptionList} className=" page_inactive  " role="button">
          案件一覧
        </a>
      );
    }
    return <></>;
  }, [user_role, has_loan_aproval_system]);
  // メンテナンス
  const jsxMaintenance = useCallback(() => {
    if (user_role === 'admin') {
      return (
        <a onClick={handleClickMaintenance} className=" page_inactive  " role="button">
          メンテナンス
        </a>
      );
    }
    return <></>;
  }, [user_role]);
  // 顧客宛文書
  const jsxCustomerDocument = useCallback(() => {
    if (has_loan_aproval_system) {
      return (
        <a onClick={handleClickCustomerDocument} className=" page_inactive  " role="button">
          顧客宛文書
        </a>
      );
    }
    return <></>;
  }, [has_loan_aproval_system]);
  // 法人一覧
  const jsxCorporateList = useCallback(() => {
    if (user_role === 'staff' && has_loan_aproval_system) {
      return (
        <a onClick={handleClickCorporateList} className=" page_inactive  " role="button">
          法人一覧
        </a>
      );
    }
    return <></>;
  }, [user_role, has_loan_aproval_system]);

  const jsxNavbar = () => {
    return (
      <div className="staff-navbar bg-white" style={{ justifyContent: 'space-around' }}>
        {jsxReceptionList()}
        {jsxMaintenance()}
        {jsxCustomerDocument()}
        {jsxCorporateList()}
      </div>
    );
  };

  return <>{jsxNavbar()}</>;
};

export default StaffNavbar;
